import axios from 'axios';

// Client for the /api/v1/me/points and /api/v1/me/friend-code endpoints.
// Caller threads in the current Firebase ID token (via CustomerContext).

const baseUrl = process.env.REACT_APP_API_HOST as string;

export type PointsLedgerEntry = {
  id: number;
  customer_id: string;
  order_id: string | null;
  source_customer: string | null;
  reason: 'purchase' | 'friend_code' | 'redemption' | 'refund_reversal' | 'adjustment';
  delta: number;
  redeemable_at: string | null;
  reversal_of: number | null;
  created_at: string;
};

export type PointsSummary = {
  available: number;
  pending: number;
  lifetime_earned: number;
  recent: PointsLedgerEntry[];
};

export type FriendCodeResponse = {
  code: string;
  first_purchase: boolean;
};

const authHeaders = (idToken: string) => ({
  Authorization: `Bearer ${idToken}`,
});

export async function getMyPoints(idToken: string): Promise<PointsSummary> {
  const res = await axios.get(`${baseUrl}/api/v1/me/points`, {
    headers: authHeaders(idToken),
  });
  return res.data;
}

export async function getMyFriendCode(idToken: string): Promise<FriendCodeResponse> {
  const res = await axios.get(`${baseUrl}/api/v1/me/friend-code`, {
    headers: authHeaders(idToken),
  });
  return res.data;
}
